export const frontmatter = {
    "draft": false,
    "title": "Equipos",
    "description": "Gestión de equipos desde la administración del sistema.",
    "sidebar_label": "Equipos",
    "sidebar_group": "referencia",
    "sidebar_order": 3
}

export const toc = []